<template>
    <flex-element
        :element-type="elementType"
        class="f-flex"
        class-default-inline="f-w-1/1 f-relative f-z-10"
    >
        <nav-dropdown
            v-for="(element, index) in elementsNew"
            :key="element.id"
            v-bind="element"
            :index="index"
            :pointer="index + 1"
            is-dynamic-element
            @element-updated="elementUpdated"
            @delete-element="onDelete"
        />

        <collection-controls @add="onAdd" @delete="onDelete" />
    </flex-element>
</template>

<script>
import { mapMutations } from 'vuex';
import uuidv4 from 'uuid/v4';

import CollectionControls from '@/components/utilities/collection-controls';
import baseOrganism from '@/mixins/base-organism/base-organism-smart';
import { Organism } from '@/data/data-models';
import { CLEAR_SELECTED_ELEMENTS } from '@/store/types/mutation-types';
import flexDeepCopy from '@/utils/flex-deep-copy';

export default {
    name: 'nav-dropdown-collection',
    components: { CollectionControls },
    mixins: [baseOrganism],

    props: {
        displayName: {
            type: String,
            default: 'Nav Dropdown Collection',
        },
    },

    mounted() {
        if (!this.elementsNew.length) {
            this.onAdd(true);
            return;
        }
    },

    methods: {
        ...mapMutations({
            clearSelectedElements: CLEAR_SELECTED_ELEMENTS,
        }),

        onAdd(isDefaultAdd) {
            const pointer = this.elementsNew.length + 1;
            let element = null;

            if (this.elementsNew.length) {
                element = { ...this.elementsNew[this.elementsNew.length - 1] };

                element.id = uuidv4();
                element = flexDeepCopy(element);
                element.name = `nav-dropdown_${ pointer }`;
            } else {
                element = new Organism({
                    id: uuidv4(),
                    name: `nav-dropdown_${ pointer }`,
                    elementType: 'nav-dropdown',
                    pointer,
                    classes: '',
                    templateType: 'Organism',
                    dataSourceId: '00000000-0000-0000-0000-000000000000',
                    elements: [],
                });
            }

            this.elementsNew.push(element);
            if (!isDefaultAdd) this.setChangedData(true);
        },

        onDelete() {
            this.elementsNew.splice(this.elementsNew.length - 1, 1);
            this.clearSelectedElements();
            this.setChangedData(true);
        },
    },
};
</script>
